export const API_URL = 'https://api.pmxchange.co/v1/';
export const SERVER_URL = 'https://api.pmxchange.co/';
export const VERSION = '2.14.03';
export const TinyEditorAPIKey = 'kbejtjil91dnjqm8a0fcd4aqyhm6feugw0mtlog40wvmhc03';
export const WEBSITE_URL = 'https://pmxchangeshop.com/';
